import { formatCurrency, LoadingSkeleton } from "shared-components";

export const FinalPrice = ({
  quantity,
  price,
  loading,
}: {
  quantity: number;
  price?: number;
  loading?: boolean;
}) => (
  <div className="mt-2 flex justify-between">
    <span>Total:</span>

    {loading ? (
      <LoadingSkeleton kind="paragraph" className="max-w-[4.25rem]" />
    ) : (
      <b>{price ? formatCurrency(price * quantity) : "R$"}</b>
    )}
  </div>
);
